import emailjs from '@emailjs/browser'
import emailConfig from '../config/email.js'

emailjs.init(emailConfig.publicKey)

export async function sendEmail({
  email,
  subject,
  message,
  name,
  inviteLink,
  homeLink,
  title,
  isTeacherInvitation = false,
  attachments = []
}) {
  try {
    if (!email || !email.trim()) {
      throw new Error('Recipient email is required')
    }

    const templateParams = {
      user_email: email.trim(),
      subject: subject || 'Invitation from Digipalz',
      message: message || '',
      name: name || email.split('@')[0],
      inviteLink: (inviteLink || '').trim(),
      homeLink: (homeLink || window.location.origin).trim(),
      title: title || 'Invitation from Digipalz',
      ...(attachments.length > 0 && { attachments: attachments })
    }

    const response = await emailjs.send(
      emailConfig.serviceId,
      emailConfig.templateId,
      templateParams
    )

    return response
  } catch (error) {
    // Don't expose EmailJS-specific error details
    throw new Error('Failed to send email. Please try again later.')
  }
}
export async function sendSupportEmail({
  userEmail,
  userName,
  subject,
  message,
  supportType,
  attachments = []
}) {
  try {
    if (!userEmail || !userEmail.trim()) {
      throw new Error('User email is required')
    }

    const templateParams = {
      to_email: 'shoaib@digipalz.io', // Your support email
      name: userName || userEmail.split('@')[0],
      from_email: userEmail.trim(),
      reply_to: userEmail.trim(), // So you can reply directly to the user
      subject: subject || 'Support Request',
      support_type: supportType || 'General Support',
      message: message || '',
      user_email: userEmail.trim(), // To show in the email body
      ...(attachments.length > 0 && { attachments: attachments })
    }

    const response = await emailjs.send(
      emailConfig.serviceId, // Use customer service template
      emailConfig.templateId2,
      templateParams
    )

    return response
  } catch (error) {
    // Don't expose EmailJS-specific error details
    throw new Error('Failed to send support email. Please try again later.')
  }
}

export async function sendStudentPasswordResetOTPEmail({
  userEmail,
  userName,
  studentName,
  password
}) {
  try {
    if (!userEmail || !userEmail.trim()) {
      throw new Error('User email is required')
    }

    const templateParams = {
      user_email: userEmail.trim(),
      userName: userName,
      studentName: studentName,
      password: password,
      subject: 'Password Reset Request'
      // homeLink: (homeLink || window.location.origin).trim(),
      // title: 'Password Reset Request'
    }

    const response = await emailjs.send(
      emailConfig.serviceId,
      emailConfig.studentPasswordResetOTPTemplateId,
      templateParams
    )

    return response
  } catch (error) {
    throw new Error(
      'Failed to send student password reset OTP email. Please try again later.'
    )
  }
}
